import { render, staticRenderFns } from "./RelayCreateOrEditBox.vue?vue&type=template&id=173ccebf&"
import script from "./RelayCreateOrEditBox.vue?vue&type=script&lang=ts&"
export * from "./RelayCreateOrEditBox.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports